import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type FC, type PropsWithChildren, useState } from 'react';
import { createQueryClient } from './createQueryClient';

const ReactQueryProvider: FC<PropsWithChildren> = ({ children }) => {
    // Use useState to ensure the same QueryClient instance is used across renders
    const [queryClient] = useState(() => createQueryClient());

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {import.meta.env.DEV && REACT_QUERY_DEVTOOLS_ENABLED && (
                <ReactQueryDevtools initialIsOpen={false} />
            )}
        </QueryClientProvider>
    );
};

export default ReactQueryProvider;
